import { createAction } from '/@/store/utils';

export const setActionExpanded = createAction('HOME:SET_ACTION_EXPANDED');
